import {useRouter} from 'next/router'
import {useCallback} from 'react'

import {PageKey} from 'lib/constants'
import {pageToHref} from 'lib/router'

function getLinkKey(workProduct: CL.TaskWorkProduct): PageKey {
  switch (workProduct.type) {
    case 'AGGREGATION_AREA':
      return 'aggregationAreas'
    case 'BUNDLE':
      return 'bundle'
    case 'OPPORTUNITY_DATASET':
      return 'opportunities'
    case 'REGIONAL_ANALYSIS':
      return 'regionalAnalysis'
    case 'DATA_SOURCE':
      return 'dataSource'
  }
}

function getLinkParams(workProduct: CL.TaskWorkProduct) {
  switch (workProduct.type) {
    case 'AGGREGATION_AREA':
      return {
        dataGroupId: workProduct.id,
        regionId: workProduct.regionId
      }
    case 'BUNDLE':
      return {
        bundleId: workProduct.id,
        regionId: workProduct.regionId
      }
    case 'OPPORTUNITY_DATASET':
      return {
        dataGroupId: workProduct.id,
        regionId: workProduct.regionId
      }
    case 'REGIONAL_ANALYSIS':
      return {
        regionalAnalysisId: workProduct.id,
        regionId: workProduct.regionId
      }
    case 'DATA_SOURCE':
      return {
        dataSourceId: workProduct.id,
        regionId: workProduct.regionId
      }
  }
}

/**
 * Hook for navigating to a work product of a task.
 */
export default function useViewWorkProduct() {
  const router = useRouter()
  return useCallback(
    (task: CL.Task) => {
      if (task.workProduct !== undefined) {
        router.push(
          pageToHref(
            getLinkKey(task.workProduct),
            getLinkParams(task.workProduct)
          )
        )
      }
    },
    [router]
  )
}
